import React, { Component } from 'react';

const Container = (WrappedComponent) => {
    class WithFetch extends Component {

        constructor(props) {
            super();
        }

        async fetch(query, options = {}) {
            const token = await this.props.getAccessToken();
            const headers = new Headers();
            const bearer = `Bearer ${token}`;
            headers.append('Authorization', bearer);
            headers.append('Accept', 'application/json');
            headers.append('Content-Type', 'application/json');
            
            const defaultOptions = {
                method: 'GET',
                headers: headers,
                ...options
            };

            return await fetch(query, defaultOptions);
        }

        render() {
            return (
                <WrappedComponent {...this.props} fetch={(query, options) => this.fetch(query, options)} />
            );
            
        }
    }

    return WithFetch;
}
export default Container;
